var scope_0 = require('/Users/arpit/dev/gatsby-theme-galleon-workspace/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1eb6f7a14c02ae861c273ced654434fc.js').default;
var scope_1 = require('/Users/arpit/dev/gatsby-theme-galleon-workspace/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/85add4b20f47a83c98fdb42cecfd26d4.js').default;
var scope_2 = require('/Users/arpit/dev/gatsby-theme-galleon-workspace/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    